import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QueryParam } from '../query-param';
import { ApiService } from '../services/api.service';

import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.css']
})
export class LoginDialogComponent implements OnInit {

  constructor(private apiService: ApiService, private activeModal: NgbActiveModal,
    private activatedRoute: ActivatedRoute, private router: Router) { }

  mobileNumber!: number;
  pinNumber!: number;

  addbalance = '';

  queryParam!: QueryParam;


  ngOnInit(): void {
    let storageName = this.apiService.getItem();
    this.queryParam = JSON.parse(
      localStorage.getItem(storageName) || 'undefined'
    );
  }

  submit() {
    console.log(this.mobileNumber);
    this.apiService.getMobilePINResponse(this.getConditionalDialogBox(this.mobileNumber, this.pinNumber)).subscribe(
      (response: any) => {
        console.log('Mobile Reponse ===============', response);
        if (response !== null) {
          this.queryParam.mobileNumber = this.mobileNumber;
          // this.queryParam.msisdn = this.mobileNumber.toString();

          this.queryParam.pin = this.pinNumber;
          this.queryParam.sub = true;
          this.queryParam.popup = false;
          let storageName = this.queryParam.id + this.queryParam.operator + this.queryParam.biller + this.queryParam.lang;
          localStorage.removeItem(storageName);
          console.log('Response 123:', this.queryParam);
          localStorage.setItem(storageName, JSON.stringify(this.queryParam));
          this.activeModal.close();
          console.log("SUBMIT", this.queryParam)
          console.log("HERE",localStorage.getItem(storageName));

          const url = this.router.createUrlTree([], {relativeTo: this.activatedRoute, 
            queryParams: {msisdn: this.mobileNumber},
            queryParamsHandling: "merge", 
            preserveFragment: true}).toString()

            this.router.navigateByUrl(url);

        } else {

          this.addbalance = 'Mobile number OR Pin Is  INVALID';
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  submitMsisdn(){
    console.log(this.mobileNumber);
    this.apiService.getMobilePINResponse(this.getConditionalDialogBoxMsisdn(this.mobileNumber)).subscribe(
      (response: any) => {
        console.log('Mobile Reponse ===============', response);
        if (response === true) {
          this.queryParam.mobileNumber = this.mobileNumber;
          // this.queryParam.msisdn = this.mobileNumber.toString();

          this.queryParam.sub = true;
          this.queryParam.popup = false;
          let storageName = this.queryParam.id + this.queryParam.operator + this.queryParam.biller + this.queryParam.lang;
          localStorage.setItem(storageName, JSON.stringify(this.queryParam));
          console.log('Response :', this.queryParam);
          this.activeModal.close();
        } else {

          this.addbalance = ' Mobile number is INACTIVE';
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
      }
    );
  }

  portalIds = ['6', '16', '32', '48', '87', '149', '152', '170', '197',
    '200', '286', '295', '296', '298', '305', '320', '322',
    '325', '327', '334', '335', '364', '370', '371', '375', '376'];

  operatorIds = ['2032', '2150', '2209', '2022', '2049', '2050', '2025', '4464',
    '2217', '2104', '2105', '5573', '8966', '9073', '9071', '2009', '2010',
    '2032', '2150', '2209', '9038', '2022', '2028', '2029', '2049', '2050', '2212',
    '2213', '2214', '2215', '2216', '2217', '2218', '2103', '7803', '2100', '2151', '9032',
    '9041', '2032', '8903'];

  getConditionalDialogBox(mobileNumber: any, pin: any) {
    if ((this.queryParam.id === '298' || this.queryParam.id === '334') && this.queryParam.biller === 'TPAY' && this.queryParam.operator === "8966") {

      return "http://wap.globocom.info/mglobopay/tpayLoginByUsername?msisdn=" + mobileNumber + "&pin=" + pin + "&operatorId=" + this.queryParam.operator;

    } else if ((this.queryParam.id == '401') && this.queryParam.biller.toLowerCase() == "ALTRUS".toLowerCase()) {

      return "http://wap.globocom.info/mglobopay/tpayLoginByUsername?msisdn=" + mobileNumber + "&pin=" + pin + "&operatorId=" + this.queryParam.operator;

    } if (this.portalIds.includes(this.queryParam.id) && this.queryParam.biller === 'TPAY' && this.operatorIds.includes(this.queryParam.operator)) {
      return "http://wap.globocom.info/mglobopay/tpayLoginByUsername?msisdn=" + mobileNumber + "&pin=" + pin + "&operatorId=" + this.queryParam.operator;
    }
    return null;
  }

  getConditionalDialogBoxMsisdn(mobileNumber: any) {

    if ((this.queryParam.id === '322' ) && this.queryParam.biller === 'TPAY') {

      return "http://wap.globocom.info/mglobopay/tpaygamesworldPortalValidation/" + mobileNumber ;
  }
  return null;


  

  }
}
